
export const ConfigHeader = () => {
  return (
    <header className="p-8 pt-24 sm:pt-8 text-center animate-fade-in">
      <h1 className="text-3xl font-heading font-bold mb-2 text-primary">Configuración</h1>
      <p className="text-foreground">Personaliza tu experiencia en Clubbers</p>
    </header>
  );
};
